import {useCallback,useEffect}from'react';import {useIntl}from'react-intl';import PropTypes from'prop-types';import DataLayerOperation from'./DataLayerOperation.js';import useRealm from'../../hooks/useRealm.js';function AnalyticsDataLayer(props) {
  var hashedCiamId = props.hashedCiamId,
    pageName = props.pageName,
    eventName = props.eventName,
    error = props.error,
    labelField = props.labelField,
    otcChannel = props.otcChannel;
  var userType = useRealm();
  var pageTitle = document.title;
  var intl = useIntl();
  var recordPageView = useCallback(function () {
    try {
      if (pageName) {
        DataLayerOperation.recordPageLoad(intl.locale, pageName, pageTitle, userType, hashedCiamId, otcChannel);
      } else if (eventName.includes('error')) {
        if (error.eventType) {
          DataLayerOperation.recordError(error.eventType, error);
        } else {
          DataLayerOperation.recordError(eventName, error);
        }
      } else {
        DataLayerOperation.recordEvent(eventName, userType, hashedCiamId, labelField);
      }
    } catch (err) {
      // Intentionally suppress errors. Don't break the app over an analytics error
    }
  }, []);
  useEffect(function () {
    recordPageView();
  }, [recordPageView]);
  return null;
}
AnalyticsDataLayer.propTypes = {
  hashedCiamId: PropTypes.string,
  pageName: PropTypes.string,
  eventName: PropTypes.string,
  error: PropTypes.object,
  labelField: PropTypes.string,
  otcChannel: PropTypes.string
};
AnalyticsDataLayer.defaultProps = {
  hashedCiamId: '',
  pageName: '',
  eventName: '',
  error: undefined,
  labelField: '',
  otcChannel: ''
};export{AnalyticsDataLayer as default};